import { BusinessInfoRevisionKind, BusinessInfoRevisionStatus } from '~/swagger/companies/Api';
import type { BusinessInfoDraftDto } from '~/swagger/companies/Api';

const SUPPLEMENT_FIELD_LOCK_STATUSES: BusinessInfoRevisionStatus[] = [
  BusinessInfoRevisionStatus.Draft,
  BusinessInfoRevisionStatus.WaitingForInformation,
  BusinessInfoRevisionStatus.Rejected,
];

export const isSupplementDocumentRequestDraft = (draft?: BusinessInfoDraftDto | null) => {
  if (!draft?.statusReason?.trim()) return false;
  if (draft.type !== BusinessInfoRevisionKind.Supplement) return false;
  return SUPPLEMENT_FIELD_LOCK_STATUSES.includes(draft.status);
};
